import { createSlice } from '@reduxjs/toolkit';
import {
  NONE_MODE,
  CREATE_MODE,
  CONSULT_MODE,
  UPDATE_MODE,
} from '../mode';
import {
  IDLE_STATUS,
  SUCCESS_STATUS,
  LOADING_STATUS,
  FAILURE_STATUS,
} from '../status';

const initialState = {
  status: IDLE_STATUS,
  mode: {
    main: NONE_MODE,
  },
  model: {},
};

const houseVolumes = createSlice({
  name: 'houseVolumes',
  initialState,
  reducers: {
    changeStatusTo: (state, action) => {
      state.status = action.payload.status;
    },
    loading: (state) => {
      state.status = LOADING_STATUS;
    },
    success: (state) => {
      state.status = SUCCESS_STATUS;
    },
    failure: (state) => {
      state.status = FAILURE_STATUS;
    },
    resetStatus: (state) => {
      state.status = IDLE_STATUS;
    },
    changeToCreateMode: (state) => {
      state.mode.main = CREATE_MODE;
    },
    changeToConsultMode: (state) => {
      state.mode.main = CONSULT_MODE;
    },
    changeToUpdateMode: (state) => {
      state.mode.main = UPDATE_MODE;
    },
    resetMode: (state) => {
      state.mode.main = NONE_MODE;
    },
    setModel: (state, action) => {
      state.model = action.payload;
    },
    resetModel: (state) => {
      state.model = initialState.model;
    },
  },
});

const {
  changeStatusTo,
  loading,
  success,
  failure,
  resetStatus,
  changeToConsultMode,
  changeToCreateMode,
  changeToUpdateMode,
  resetMode,
  setModel,
  resetModel,
} = houseVolumes.actions;

const houseVolumesSliceActions = {
  ...houseVolumes.actions,
};

const selectStatus = (state) => state.houseVolumes.status;
const selectMode = (state) => state.houseVolumes.mode.main;
const selectModel = (state) => state.houseVolumes.model;
const selectHouseVolumes = (state) => state.houseVolumes.model;

const houseVolumesSelectors = {
    selectStatus,
    selectMode,
    selectModel,
};

export {
    houseVolumes,
    changeStatusTo,
    loading,
    success,
    failure,
    resetStatus,
    changeToConsultMode,
    changeToCreateMode,
    changeToUpdateMode,
    resetMode,
    setModel,
    resetModel,
    houseVolumesSliceActions,
    selectStatus,
    selectMode,
    selectModel,
    selectHouseVolumes,
    houseVolumesSelectors,
};

export default houseVolumes.reducer;